import { render, staticRenderFns } from "./EmailAnimation.vue?vue&type=template&id=6d508bd4&scoped=true"
import script from "./EmailAnimation.vue?vue&type=script&lang=js"
export * from "./EmailAnimation.vue?vue&type=script&lang=js"
import style0 from "./EmailAnimation.vue?vue&type=style&index=0&id=6d508bd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d508bd4",
  null
  
)

export default component.exports